<template>
  <div class="bg">
    <div class="container">
      <div class="row">
        <div class="col-md-2">
          <home-help-navi></home-help-navi>
        </div>
        <div class="col-md-10">
          <home-help-content></home-help-content>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import HomeHelpContent from './HomeHelpContent'
  import HomeHelpNavi from './HomeHelpNavi'
  export default {
    components: {HomeHelpNavi, HomeHelpContent}, name: 'homeHelp'
  }
</script>

<style scoped>
  .bg {
    display: flex;
  }
  .container {
    padding: 0;
    width: 1100px;
    margin: auto;
  }
  .row {
    padding: 0;
    padding-top: 2%;
    padding-bottom: 2%;
    margin: 0;
  }
  .col-md-2 {
    padding-left: 0;
  }
  .col-md-10 {
    padding-right: 0;
  }
</style>





// WEBPACK FOOTER //
// HomeHelp.vue?f41fc202